site.registerService('HttpClient', function () {
    "use strict";

    /**
     * @class
     */
    function HttpClient() {
        this.cache = {};
    }

    HttpClient.prototype.get = function (url, data) {
        var controller = new AbortController();

        var query = Object.entries(data || {}).map(function (pair) { return pair.map(encodeURIComponent).join('='); }).join('&');
        if (query) {
            query = '?' + query;
        }

        var request = window.fetch(url + query, { method: 'GET', signal: controller.signal })
            .then(function (response) {
                if (!response.ok) {
                    throw response;
                }

                return response.json();
            });

        return cancelableify(request, controller);
    };

    HttpClient.prototype.post = function (url, data) {
        var controller = new AbortController();

        var request = window.fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
            signal: controller.signal
        })
            .then(function (response) {
                if (!response.ok) {
                    throw response;
                }

                return response.json();
            });

        return cancelableify(request, controller);
    };

    // cache response
    HttpClient.prototype.getCached = function (url, data) {
        var cacheKey = JSON.stringify(arguments);
        if (this.cache[cacheKey]) return this.cache[cacheKey];

        return this.cache[cacheKey] = this.get(url, data)
            .catch(function (e) {
                delete this.cache[cacheKey];
                throw e;
            });
    };

    HttpClient.prototype.postCached = function (url, data) {
        var cacheKey = JSON.stringify(arguments);
        if (this.cache[cacheKey]) return this.cache[cacheKey];

        return this.cache[cacheKey] = this.post(url, data)
            .catch(function (e) {
                delete this.cache[cacheKey];
                throw e;
            });
    };


    // ====== cancelable promise ====== //
    function cancelableify(promise, controller) {
        promise.cancel = function() {
            controller.abort();
        };

        var thenFn = promise.then;
        promise.then = function () {
            var newPromise = thenFn.apply(this, arguments);
            return cancelableify(newPromise, controller);
        };

        var catchFn = promise.catch;
        if (catchFn) {
            promise.catch = function () {
                var newPromise = catchFn.apply(this, arguments);
                return cancelableify(newPromise, controller);
            };
        }

        var finallyFn = promise.finally;
        if (finallyFn) {
            promise.finally = function () {
                var newPromise = finallyFn.apply(this, arguments);
                return cancelableify(newPromise, controller);
            };
        }

        return promise;
    }
    // ====== cancelable promise ====== //


    // export
    return new HttpClient();

});